// config/courses.js
export const courseOptions = {
  school: {
    label: 'School',
    options: [
      { value: 'KG to 8th GRADE', label: 'KG to 8th GRADE' },
      { value: '9th to 12th GRADE', label: 'High School - 9th to 12th GRADE' },
    ],
  },
  college: {
    label: 'College',
    options: [
      { value: 'Bachelor of Science', label: 'Bachelor of Science' },
      { value: 'Bachelor of Arts', label: 'Bachelor of Arts' },
      { value: 'Bachelor of Commerce', label: 'Bachelor of Commerce' },
      { value: 'Master of Science', label: 'Master of Science' },
    ],
  },
  professional: {
    label: 'Professional Courses',
    options: [
      { value: 'Engineering', label: 'Engineering' },
      { value: 'B.Arch', label: 'B.Arch' },
      { value: 'MBBS', label: 'MBBS' },
      { value: 'Pharma', label: 'Pharma' },
    ],
  },
};
